import React from 'react';
import pt from 'prop-types';

import { Form, Field } from 'components/form';
import Modal from 'components/modal';

export default class ChangePassword extends React.PureComponent {
  static propTypes = {
    title: pt.string,
    action: pt.string,
    width: pt.number,
    showError: pt.bool,
    large: pt.bool,
    onSubmit: pt.func,
    onCancel: pt.func,
  };

  static contextTypes = {
    closeModal: pt.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  onSubmitForm = async ({ password }) => {
    const { onSubmit } = this.props;

    if (onSubmit) {
      this.setState({ loading: true });

      const result = await onSubmit(password);

      this.setState({ loading: false });

      if (!result) {
        return;
      }
    }

    this.context.closeModal();
  };

  onClickCancel = (event) => {
    event.preventDefault();

    this.props.onCancel?.();
    this.context.closeModal();
  };

  render() {
    const {
      title,
      action = 'Save password',
      width = 700,
      showError = true,
      large = false,
    } = this.props;
    const { loading } = this.state;

    return (
      <Form onSubmit={this.onSubmitForm} autoFocus={true}>
        <Modal
          title={title || 'Change password'}
          actions={[
            {
              label: action,
              type: 'submit',
            },
            { label: 'Cancel', type: 'cancel', onClick: this.onClickCancel },
          ]}
          width={width}
          onClose={this.onClickCancel}
          cancel={false}
          closable={true}
          loading={loading}
        >
          <fieldset>
            <Field
              name="password"
              type="password"
              label="New password"
              placeholder="********"
              rules={['password', 'required']}
              showError={showError}
              large={large}
            />
          </fieldset>
        </Modal>
      </Form>
    );
  }
}
